module.exports = __webpack_public_path__ + "img/mondial.6dea58c0.png";